import React from 'react';
import Preparing from '../../components/Preparing/Preparing';

const MedalPage = () => {
    return (
        <div>
            <div className='text-center mt-8 mb-8 text-2xl font-bold'>매달각인</div>
            <hr  className=' ml-28 mr-28'/>
            <Preparing/>
        </div>
    );
};

export default MedalPage;